// SmartCues authorized email groups
export const SMARTCUES_AUTHORIZED_GROUPS = [
  'nebulaengg@microsoft.com',
  'piesa@microsoft.com'
];

// Check if user has access to SmartCues based on group membership
export const checkSmartCuesAccess = (userGroups: string[] | undefined): boolean => {
  return userGroups ? SMARTCUES_AUTHORIZED_GROUPS.some(group => userGroups.includes(group)) : false;
};